"use strict";

exports.__esModule = true;
exports.payloadReducer = payloadReducer;

function payloadReducer(payloadKey, defaultValue) {
  return function (state, action) {
    if (state === void 0) {
      state = defaultValue;
    }

    var type = action.type,
        payload = action.payload;
    var endState = state;

    if (type === payloadKey) {
      endState = payload;
    }

    return endState;
  };
}